<div mat-dialog-content>
  <div class="mainDiv">

    <button mat-button class="btn1" style="float: right;top: 9px;
       left: -10px;" (click)="onNoClicks('No')"> X </button>
    <div>
      <p mat-dialog-title>
        We have the details for the latest ticket only. For older tickets, please check salesforce database.</p>
    </div>
    <form [formGroup]="formDetail">
    </form>
  </div>
</div>
<style>
  .btn1 {
    float: right;
    height: 34px;
    left: 0px;
    width: 2px;
    min-width: 41px;
    font-size: 18px;
    top: 2px;
   
    /* width: 25px; */
    color: white;
    background-color: #234a90;
  }

  /* .mainDiv {
    padding: 20px 20px 10px 20px;
  }


  .mat-dialog-content {
    display: block;
    padding: 4px;
    border-radius: 4px;
    box-sizing: border-box;
    outline: 0;
    width: 103%;
    height: 90%;
    min-height: inherit;
    max-height: inherit;
    overflow: hidden;
  }

  .mat-dialog-title {
    margin-top: 15px;
    margin-right: 8px;
    margin-left: 21px;
  } */
  .mat-dialog-title {
    margin: 7px 4px 22px;
    display: inline-block;
    margin-left: 23px;
    margin-right: 0px;
    margin-top: 13px;
    box-sizing: border-box;
    border: gray;
  }
  ::ng-deep .mat-dialog-container {
    overflow: hidden !important;
    width: 96%;
    height: 97%;
    display: block;
    padding: 0px !important;
    border-radius: 4px;
    box-sizing: border-box;

    outline: 0;

    min-height: inherit;
    max-height: inherit;
  }

  /* .mat-dialog-container {
    display: block;
    padding: 24px;
    border-radius: 4px;
    box-sizing: border-box;
    outline: 0;
    width: 88%;
    height: 89%;
    min-height: inherit;
    max-height: inherit;
    overflow: hidden;
} */
  /* style attribute {
    max-width: 80vw;
    pointer-events: auto;
    width: 28%;
    height: 27%;
    position: static;
} */
</style>